import React from 'react';
import { Navigate } from 'react-router-dom';
import { useAuth } from '../contexts/AuthContext';

interface PrivateRouteProps {
  children: React.ReactNode;
  requireViewer?: boolean;
  requireAdmin?: boolean;
}

const PrivateRoute: React.FC<PrivateRouteProps> = ({ children, requireViewer = false, requireAdmin = false }) => {
  const { user, loading, canView, canAdmin } = useAuth();

  if (loading) {
    return (
      <div style={{ 
        display: 'flex', 
        justifyContent: 'center', 
        alignItems: 'center', 
        height: '100vh' 
      }}>
        <p>Loading...</p>
      </div>
    );
  }

  if (!user) {
    return <Navigate to="/login" replace />;
  }

  // 권한 체크: admin 권한이 필요한 경우
  if (requireAdmin && !canAdmin()) {
    return (
      <div style={{ 
        display: 'flex', 
        flexDirection: 'column',
        justifyContent: 'center', 
        alignItems: 'center', 
        height: '100vh' 
      }}>
        <h2>접근 권한이 없습니다</h2>
        <p>이 페이지를 보려면 Admin 권한이 필요합니다.</p>
        <p>현재 권한: {user.role}</p>
      </div>
    );
  }

  // 권한 체크: viewer 권한이 필요한 경우
  if (requireViewer && !canView()) {
    return (
      <div style={{ 
        display: 'flex', 
        flexDirection: 'column',
        justifyContent: 'center', 
        alignItems: 'center', 
        height: '100vh' 
      }}>
        <h2>접근 권한이 없습니다</h2>
        <p>이 페이지를 보려면 Viewer 이상의 권한이 필요합니다.</p>
        <p>현재 권한: {user.role}</p>
      </div>
    );
  }

  return <>{children}</>;
};

export default PrivateRoute;